import Hero from "@/components/ui/Hero";
import CTABlock from "@/components/ui/CTABlock";
import LocationCard from "@/components/ui/LocationCard";
import SwflMap from "@/components/ui/SwflMap";
import { LOCATIONS } from "@/data/locations";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function ServiceAreasHub() {
    useDocumentTitle(
        "Service Areas · Naples, Fort Myers, Cape Coral · A1 Screening",
        "A1 Screening serves Naples (home base), Fort Myers, Cape Coral, Lehigh Acres, and Bonita Springs across Southwest Florida."
    );
    const naples = LOCATIONS.find((l) => l.is_primary);
    const secondary = LOCATIONS.filter((l) => !l.is_primary);

    return (
        <>
            <Hero
                eyebrow="Service Areas"
                title="Where We Work in Southwest Florida"
                subtitle="Naples is our home base. We also serve Fort Myers, Cape Coral, Lehigh Acres, and Bonita Springs."
            />
            <section className="a1-section">
                <div className="a1-container">
                    <div className="grid lg:grid-cols-12 gap-8 items-start">
                        <div className="lg:col-span-5">
                            <SwflMap />
                        </div>
                        <div className="lg:col-span-7 flex flex-col gap-5">
                            <LocationCard location={naples} featured />
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                                {secondary.map((l) => <LocationCard key={l.slug} location={l} />)}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <CTABlock />
        </>
    );
}
